import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Store} from '@ngrx/store';
import {filter, take} from 'rxjs/operators';
import { State } from '../../State';
import { getPracticeTypesFetched } from '../../State/selectors/mdqx/selectors';
import { GetPracticeTypesRequest } from '../../State/actions/mdqx/practice-type.actions';

@Injectable({
    providedIn: 'root'
})
export class PracticeTypeResolver implements Resolve<boolean> {
    constructor(private store: Store<State>) {}

    resolve() {
        const value$ = this.store.select(getPracticeTypesFetched);

        value$
            .pipe(take(1))
            .subscribe(
                fetched =>
                    !fetched &&
                    localStorage.getItem('token') != null &&
                    this.store.dispatch(new GetPracticeTypesRequest())
            );

        return value$.pipe(
            filter(v => v),
            take(1)
        );
    }
}
